const TRIAL_STATE_KEY = 'trial_state';

export function useTrialPersistence() {
	const getPersistedState = () => {
		try {
			const saved = sessionStorage.getItem(TRIAL_STATE_KEY);
			return saved ? JSON.parse(saved) : {};
		} catch {
			return {};
		}
	};

	const getPersistedValue = (key) => {
		const persistedState = getPersistedState();
		return persistedState[key];
	};

	const persistState = (stateObject) => {
		try {
			sessionStorage.setItem(TRIAL_STATE_KEY, JSON.stringify(stateObject));
		} catch (error) {
			console.warn('Error persisting trial state:', error);
		}
	};

	const clearPersistedState = () => {
		sessionStorage.removeItem(TRIAL_STATE_KEY);
	};

	return {
		getPersistedValue,
		persistState,
		clearPersistedState,
	};
}
